import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface ContentProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useContent = (props: ContentProps) => {
  const departmentDetails = useSelector(
    (state: RootState) => state.department.departmentDetails
  )

  return {
    ...props,
    departmentDetails,
  }
}
